// Helpers per etichettare le quantità in base all'imballo dell'ordine/articolo.
// Non tocca il modello dati: cambia SOLO l'etichetta mostrata a schermo/stampa.
export const IMBALLO_OPTIONS = [
    { value: "cartoni",   label: "Cartoni" },
    { value: "vaschette", label: "Vaschette" },
];

export function imballoOf(o) {
    // o = ordine o articolo (fallback a "cartoni")
    if (!o) return "cartoni";
    return o.imballo_eff || o.imballo_override || o.imballo || "cartoni";
}

export function isVaschette(o) { return imballoOf(o) === "vaschette"; }

// singolare/plurale in minuscolo (default): "cartone" / "cartoni" o "vaschetta" / "vaschette"
export function unitLabel(o, opts = {}) {
    const isVas = isVaschette(o);
    const singular = opts.singular === true;
    if (opts.upper) return isVas ? (singular ? "VASCHETTA" : "VASCHETTE") : (singular ? "CARTONE" : "CARTONI");
    if (opts.title) return isVas ? (singular ? "Vaschetta" : "Vaschette") : (singular ? "Cartone" : "Cartoni");
    return isVas ? (singular ? "vaschetta" : "vaschette") : (singular ? "cartone" : "cartoni");
}

// Contenitore singolare ("cartone" / "vaschetta"), utile per "Peso cartone", "Rotoli per cartone", ecc.
export function packagingSingular(o, opts = {}) {
    const isVas = isVaschette(o);
    if (opts.upper) return isVas ? "VASCHETTA" : "CARTONE";
    if (opts.title) return isVas ? "Vaschetta" : "Cartone";
    return isVas ? "vaschetta" : "cartone";
}

// Abbreviazione (usata in "Xcart./pedana" o "Xvas./pedana")
export function unitAbbrev(o) { return isVaschette(o) ? "vasc." : "cart."; }

// Etichette pronte per label frequenti
export function labelPianificati(o) { return `${unitLabel(o, {title:true})} pianifica${isVaschette(o) ? "te" : "ti"}`; }
export function labelProdotti(o)    { return `${unitLabel(o, {title:true})} prodott${isVaschette(o) ? "e" : "i"}`; }
export function labelPerPedana(o)   { return `${unitLabel(o, {title:true})}/pedana`; }
